import { IUpdateAtributosObrasCadastroUseCase } from "../../../presentation/useCases/update/update_atributos_obras_cadastro_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateAtributosObrasCadastroUseCase
 */

export class UpdateAtributosObrasCadastroUseCase implements IUpdateAtributosObrasCadastroUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async updateAtributosObrasCadastro(
    idAtributosObras: number,
    exibirDataChecklist: boolean,
    exibirDataInspecao: boolean,
    exibirDataAprovacaoFinal: boolean
  ): Promise<void> {
    await this.repository.updateAtributosObrasCadastro(idAtributosObras, exibirDataChecklist, exibirDataInspecao, exibirDataAprovacaoFinal);
  }
}
